module.exports = __webpack_public_path__ + "c627fb9e057fbdc3d5cdb1cb7b002023.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/routes/Confirmation/vcc.png
// module id = 1052
// module chunks = 0